import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-column gap-2 my-3" };
const _hoisted_2 = { class: "flex flex-column gap-1" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("span", null, "URL", -1);
import OneDeskTagsAutoComplete from "@/components/atoms/OneDeskTagsAutoComplete.vue";
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
import OneDeskInput from "@/components/atoms/OneDeskInput.vue";
import { mandatoryField, maxLength, minLength, validateURL } from "@/shared/utils/validation";
import { ref } from "vue";
import { createLink, updateLink } from "@/repositories/links.repository";
import useToastNotify from "@/shared/composables/toastNotifyHelper";
import useFormValidation from "@/shared/composables/useFormValidation";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskLinkEdit',
    props: {
        "modelValue": { required: true },
        "modelModifiers": {},
    },
    emits: /*#__PURE__*/ _mergeModels(['link-updated'], ["update:modelValue"]),
    setup(__props, { emit: __emit }) {
        const modelValue = _useModel(__props, "modelValue");
        const link = ref({ ...modelValue.value });
        const notify = useToastNotify();
        const { validationStateDict, invalidForm } = useFormValidation();
        const emit = __emit;
        const save = async () => {
            if (invalidForm.value || !link.value)
                return;
            if (link.value.id) {
                await updateLink(link.value);
                notify('', 'Link updated', 'success');
                emit('link-updated');
            }
            else {
                await createLink(link.value);
                notify('', 'Link created', 'success');
                emit('link-updated');
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(OneDeskTagsAutoComplete, {
                            "data-testid": "link-label",
                            modelValue: link.value.label,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((link.value.label) = $event)),
                            "onUpdate:valid": _cache[1] || (_cache[1] = ($event) => (_unref(validationStateDict).label = $event)),
                            label: "Key",
                            rules: [_unref(mandatoryField), _unref(minLength)(3), _unref(maxLength)(40)]
                        }, null, 8, ["modelValue", "rules"]),
                        _createVNode(OneDeskInput, {
                            "data-testid": "link-url",
                            rules: [_unref(mandatoryField), _unref(validateURL)],
                            modelValue: link.value.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((link.value.value) = $event)),
                            label: "URL",
                            placeholder: "Enter a URL",
                            "onUpdate:valid": _cache[3] || (_cache[3] = ($event) => (_unref(validationStateDict).value = $event))
                        }, {
                            label: _withCtx(() => [
                                _hoisted_3
                            ]),
                            _: 1
                        }, 8, ["rules", "modelValue"])
                    ])
                ]),
                _createVNode(OneDeskButton, {
                    "data-testid": "save-link",
                    severity: "primary",
                    icon: "pi pi-save",
                    onClick: save,
                    label: "Save",
                    disabled: _unref(invalidForm)
                }, null, 8, ["disabled"])
            ], 64));
        };
    }
});
